// extracted by mini-css-extract-plugin
module.exports = {"fieldWithIcon":"FieldIcon_fieldWithIcon__2SHjS","iconWrapper":"FieldIcon_iconWrapper__2_lki","icon":"FieldIcon_icon__EF8An"};